import { REPORT_TEMPLATE, type IReportCardInfo, type TechChallengeCardData } from '@/types';
import type { BaseCardService } from './abstract-base-card-service';
import { BaseCardServiceImpl, type BaseReportCardData } from './abstract-base-card-service';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { ReportApiService } from '@/infrastructure/api-functions/report-api-service';
import _ from 'lodash'
import { I18nService } from '../i18n-service';

export const TechChallengeService = Symbol('TechChallengeService');

export type TechChallengeService = BaseCardService<TechChallengeCardData>

@injectable()
export class TechChallengeServiceImpl extends BaseCardServiceImpl<TechChallengeCardData> implements TechChallengeService {
    _modelData = {
        isLoading: false,
        isFailed: false,
        isSuccess: false,
        data: undefined,
    };

    templateType = REPORT_TEMPLATE.TECHNOLOGY_STATUS_CHALLENGES;

    constructor(
    @inject(ReportApiService) _reportApiService: ReportApiService,
    @inject(I18nService) private readonly _i18nService: I18nService
    ) {
        super(
            _reportApiService
        );
    }

    private _getTechChallengeData(cardData: BaseReportCardData<IReportCardInfo>): TechChallengeCardData {
        const techChallengeData = cardData.data?.[REPORT_TEMPLATE.TECHNOLOGY_STATUS_CHALLENGES]
        return {
            description: techChallengeData?.TECHNOLOGY_STATUS_GPT?.join('\n\n') || this._i18nService.t('report.noData'),
            patentChartData: _.isEmpty(techChallengeData?.TECHNOLOGY_STATUS_PATENT_CHART) ? undefined : techChallengeData?.TECHNOLOGY_STATUS_PATENT_CHART,
            paperChartData: _.isEmpty(techChallengeData?.TECHNOLOGY_STATUS_PAPER_CHART) ? undefined : techChallengeData?.TECHNOLOGY_STATUS_PAPER_CHART,
        }
    }

    updateFetchData(getUpdateValue: (v: BaseReportCardData<IReportCardInfo>) => BaseReportCardData<IReportCardInfo>): void {
        const updatedValue = getUpdateValue(_.omit(this.modelData, 'data'));

        const dataHaveFromUpdated = _.has(updatedValue, 'data')
        if (dataHaveFromUpdated) {
            this.update(modelData => ({
                ...modelData,
                ...updatedValue,
                data: this._getTechChallengeData(updatedValue),
            }));
        } else {
            this.update(m => ({
                ...m,
                ...updatedValue,
                data: m.data,
            }));
        }
    }
}
